import React from "react";
import "../style/Header.css";
import logo from "../logo.png";
import { Link } from "react-router-dom";

class Header extends React.Component {
  state = {
    state: {
      showNav: false,
    },
  };

  openNavClick = (e) => {
    e.preventDefault();
    this.openNav();
  };

  closeNavClick = (e) => {
    e.preventDefault();
    this.closeNav();
  };

  openNav = () => {
    this.setState({
      showNav: true,
    });
  };

  closeNav = () => {
    this.setState({
      showNav: false,
    });
  };

  render() {
    const { showNav } = this.state;
    let navCoverStyle = { width: showNav ? "100%" : "0" };
    let sideNavStyle = { width: showNav ? "400px" : "0" };

    return (
      <div className="allHeader">
        <div
          onClick={this.navCoverClick}
          className="nav-cover"
          style={navCoverStyle}
        />
        <div name="side-nav" className="side-nav" style={sideNavStyle}>
          <div className="sideNavTop">
            <Link to={`/`}>
              <img src={logo} alt="brainster_logo" />
            </Link>
            <a
              href="http://"
              onClick={this.closeNavClick}
              className="close-nav"
            >
              <i className="fa fa-times fa-lg" aria-hidden="true"></i>
              Затвори
            </a>
          </div>
          <div className="sideNavLink">
            <a href="https://brainster.co/singin">Регистрирај се</a>
            <hr />
            <a href="https://brainster.co/singup">Најави се</a>
            <hr />
            <a href="https://brainster.co/about">За нас</a>
            <hr />
            <a
              href="https://www.facebook.com/pg/brainster.co/photos/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Галерија
            </a>
            <hr />
            <a
              href="https://brainster.co/contact"
              target="_blank"
              rel="noopener noreferrer"
            >
              Контакт
            </a>
            <hr />
          </div>
        </div>

        <div className="Header">
          <div className="hamburger" onClick={this.openNavClick}>
            <i className="fa fa-bars fa-lg" aria-hidden="true"></i>
            Мени
          </div>
          <Link to={`/`}>
            <img className="imgHeader" src={logo} alt="brainster_logo" />
          </Link>
          <div className="buttons">
            <button className="yellowBtn">
              <a
                href="https://www.brainster.io/business"
                target="_blank"
                rel="noopener noreferrer"
              >
                Обуки за компании
              </a>
            </button>
            <button className="blackBtn">
              <a
                href=" https://www.brainster.io/business"
                target="_blank"
                rel="noopener noreferrer"
              >
                Вработи наши студенти
              </a>
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default Header;
